const footerNav = [
  { title: '吃瓜栏目', links: ['今日热瓜', '围观现场', '吃瓜分类', '吃瓜指南', '考古专区'] },
  { title: '快速帮助', links: ['常见问题', '吃瓜边界', '爆料投稿', '关于口碑', '内容原则'] },
];

export default function Footer() {
  return (
    <footer className="bg-background-200/60 pt-12 text-foreground-700">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-8 pb-10 sm:grid-cols-2 lg:grid-cols-4">
          <div className="sm:col-span-2 lg:col-span-2">
            <a href="#top" className="flex items-center gap-2 whitespace-nowrap">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50">
                <i className="ri-cup-line text-lg"></i>
              </span>
              <span className="font-heading text-xl leading-none text-primary-600">呱呱吃瓜</span>
            </a>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-foreground-600">
              前排围观现场 · 实时吃瓜蹲后续。把娱乐八卦与热点事件摆到前排，让你看得明白、聊得尽兴，在线吃瓜不落单。
            </p>
            <div className="mt-5 flex items-center gap-3">
              {['ri-weibo-fill', 'ri-twitter-x-fill', 'ri-bilibili-fill', 'ri-douban-fill'].map((ic) => (
                <a
                  key={ic}
                  href="#top"
                  aria-label={`呱呱吃瓜 ${ic}`}
                  className="flex h-10 w-10 items-center justify-center rounded-full bg-background-50 text-lg text-foreground-500 transition-colors hover:bg-primary-500 hover:text-background-50"
                >
                  <i className={ic}></i>
                </a>
              ))}
            </div>
          </div>

          {footerNav.map((col) => (
            <div key={col.title}>
              <h3 className="text-sm font-bold text-foreground-900">{col.title}</h3>
              <ul className="mt-4 flex flex-col gap-2.5">
                {col.links.map((l) => (
                  <li key={l}>
                    <a href="#top" className="text-sm text-foreground-600 transition-colors hover:text-primary-600">
                      {l}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="flex flex-col items-center justify-between gap-3 border-t border-background-300/60 py-5 text-xs text-foreground-500 sm:flex-row">
          <p>© 2026 呱呱吃瓜 · 前排围观，理性吃瓜，拒绝造谣传谣。</p>
          <p>本站内容仅供娱乐资讯交流 · 请文明用语</p>
        </div>
      </div>
    </footer>
  );
}